import { ArrowUp, ArrowDown, Trash2, Plus } from "lucide-react";
import { In, Area, Toggle } from "./kit";

const swap = (arr, i, j) => { const n = [...arr]; [n[i], n[j]] = [n[j], n[i]]; return n; };

export const PointsEditor = ({ items = [], onChange, testid, simple = false }) => {
  const upd = (i, k, v) => onChange(items.map((x, j) => (j === i ? (simple ? v : { ...x, [k]: v }) : x)));
  return (
    <div className="space-y-3" data-testid={testid}>
      {items.map((it, i) => (
        <div key={i} className="flex gap-3 border border-[#27272A] p-3">
          <div className="flex flex-col">
            <button disabled={i === 0} onClick={() => onChange(swap(items, i, i - 1))} className="p-1 text-zinc-500 disabled:opacity-20" aria-label="Move up"><ArrowUp size={14} /></button>
            <button disabled={i === items.length - 1} onClick={() => onChange(swap(items, i, i + 1))} className="p-1 text-zinc-500 disabled:opacity-20" aria-label="Move down"><ArrowDown size={14} /></button>
          </div>
          <div className="flex-1 space-y-2">
            {simple ? <In value={it} onChange={(v) => upd(i, null, v)} testid={`${testid}-item-${i}`} /> : <>
              <In value={it.title} onChange={(v) => upd(i, "title", v)} placeholder="Title" testid={`${testid}-title-${i}`} />
              <Area value={it.body} onChange={(v) => upd(i, "body", v)} rows={2} placeholder="Body" testid={`${testid}-body-${i}`} />
            </>}
          </div>
          <button onClick={() => onChange(items.filter((_, j) => j !== i))} className="p-1 text-zinc-500 hover:text-red-400 self-start" aria-label="Remove" data-testid={`${testid}-remove-${i}`}><Trash2 size={14} /></button>
        </div>
      ))}
      <button onClick={() => onChange([...items, simple ? "" : { title: "", body: "" }])} className="flex items-center gap-2 text-sm text-[#00E5FF]" data-testid={`${testid}-add`}><Plus size={14} />Add item</button>
    </div>
  );
};

const LABELS = { portfolio: "Featured portfolio", services: "Service categories", pricing: "Pricing overview", how_it_works: "How it works", why: "Why EditBay", agency: "Agency & white-label", about: "About — EditBay by Relatable Studio", faqs: "FAQs", cta: "Project enquiry CTA" };

export const SectionsEditor = ({ sections = [], onChange }) => {
  const upd = (i, k, v) => onChange(sections.map((x, j) => (j === i ? { ...x, [k]: v } : x)));
  return (
    <div className="divide-y divide-[#27272A] border border-[#27272A]" data-testid="sections-editor">
      {sections.map((s, i) => (
        <div key={s.key} className="flex gap-4 p-4 items-start">
          <div className="flex flex-col">
            <button disabled={i === 0} onClick={() => onChange(swap(sections, i, i - 1))} className="p-1 text-zinc-500 disabled:opacity-20" aria-label="Move up" data-testid={`section-up-${s.key}`}><ArrowUp size={14} /></button>
            <button disabled={i === sections.length - 1} onClick={() => onChange(swap(sections, i, i + 1))} className="p-1 text-zinc-500 disabled:opacity-20" aria-label="Move down" data-testid={`section-down-${s.key}`}><ArrowDown size={14} /></button>
          </div>
          <div className="flex-1 grid md:grid-cols-2 gap-2">
            <p className="md:col-span-2 eb-label">{LABELS[s.key] || s.key}</p>
            <In value={s.title} onChange={(v) => upd(i, "title", v)} placeholder="Section title" testid={`section-title-${s.key}`} />
            <In value={s.subtitle} onChange={(v) => upd(i, "subtitle", v)} placeholder="Subtitle" testid={`section-subtitle-${s.key}`} />
          </div>
          <div className="w-28"><Toggle label="Visible" checked={s.visible} onChange={(v) => upd(i, "visible", v)} testid={`section-visible-${s.key}`} /></div>
        </div>
      ))}
    </div>
  );
};
